import React, { Component } from 'react';

import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";

// add form components
import { Form, Input, Button, Alert } from 'antd';

import { connect } from 'react-redux';
import {User} from '../../actions/user';

import Loader from '../../components/Loader';
import Api from '../../api/Api';

// import ValidatorHelper from '../../helpers/ValidatorHelper';
import LayoutHelper from '../../helpers/LayoutHelper';

import Main from '../../components/Main';

class ResetPassword extends Component { 
    constructor(props) {
        super();
        this.state = {

            dashboard: false,
            login: false,

            loading: false,

            error_message: '',
            success_message: '',

            password: '',
            confirm_password: '',
            
            password_error: false,
            confirm_password_error: false,
            
            status_error: '',
            status_success: '',

            user: false,
            user_token: false,

            redirect: false,
            logout: false,

            code: false
        }
    }

    componentDidMount = () => {

        var code = this.props.code;

        if(code){

            this.setState({code: code});
        }else{

            this.setState({logout: true});
        }
    }

    render () {

        if(this.state.redirect){
            return <Redirect to="/login" />;
        }

        if(this.state.logout){
            return <Redirect to="/logout" />
        }

        const layout = {
            labelCol: { span: 24 },
            wrapperCol: { span: 24 },
        };

        const tailLayout = {
            wrapperCol: { span: 24 },
        };

        const validateMessages = {
            required: '${label} is required!',
            types: {
              email: '${label} is not valid!',
              number: '${label} is not a valid number!',
            },
        };

        return (

            <Main page="reset_password" className="login-main-page">
                <div className="container">
                    <div className="login-page d-flex items-end">
                        <div className="right half-container self-right auth-block" style={{position:'relative'}}>

                            <div className="section-heading">Reset Password</div>

                            {/* using if statement */}
                            {this.state.message &&
                                <Alert message="Success" description={this.state.message} type="success" closable />
                            }

                            {this.state.error_message &&
                                <Alert message="Error" description={this.state.error_message} type="error" closable />
                            }

                            <Form {...layout} name="reset_password_form" validateMessages={validateMessages} onFinish={this.loginSubmit.bind(this)}>
                                <Form.Item label="New Password" name="password" rules={[{required:true, message:'Please enter new password!'}]}>
                                    <Input.Password />
                                </Form.Item>

                                <Form.Item label="Confirm Password" name="con_password" dependencies={['password']} rules={[{required:true, message:'Please enter confirm password!'},
                                ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject('Entered passwords do not match!');
                                    },
                                }),]}>
                                    <Input.Password />
                                </Form.Item>

                                <Form.Item {...tailLayout} className="text-center mt-2">
                                    <Button type="danger" htmlType="submit" loading={this.state.loading}>Submit</Button>
                                </Form.Item>

                                <div className="text-center">
                                    <Link to="/login">Back to login</Link>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </Main>
        )
    }

    loginSubmit = (values) => {

        const formData = new FormData();

        Object.keys(values).forEach(key => formData.append(key, values[key]))

        formData.append('code', this.props.code);

        var that = this;
        that.setState({loading: true});
    
        Api.post('auth/reset_password', formData, function(data){
        
            that.setState({loading:false, password:'', confirm_password:''});

            if(data.status == true){
                
                LayoutHelper.addSuccessMessage(that, data.message);
                window.setTimeout(() => {

                    that.setState({redirect: true});
                }, 2000);

            }else{

                that.setState({error_message: data.message});
                LayoutHelper.addErrorMessage(that, data.message);
            }
        });
    }
}

const mapStateToProps = state => {
	return {
        user: state.user.user
	}
}

export default connect(mapStateToProps, { User } )(ResetPassword);
